<template>
  <div class="kpi-widget">
    <div class="kpi-label">{{ title }}</div>
    <div class="kpi-value">{{ formattedValue }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  value: { type: [Number, String], required: true }
});

const formattedValue = computed(() => {
  if (typeof props.value === 'number') {
    return props.value.toLocaleString('es-ES');
  }
  return props.value;
});
</script>

<style scoped>
.kpi-widget {
  background: white;
  border-radius: 4px;
  padding: 12px 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e8e8e8;
  height: 80px;
}

.kpi-label {
  font-size: 0.72rem;
  color: #888;
  font-weight: 500;
  margin-bottom: 2px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-family: 'Source Sans Pro', sans-serif;
}

.kpi-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #333;
  font-family: 'Source Sans Pro', sans-serif;
}
</style>
